export class GetDistanceToPlantDataInputs {
    zip: string;
    miles: number;
    countryID: string;
    constructor(zip, miles, countryid) {
        this.zip = zip;
        this.miles = miles;
        this.countryID = countryid;
    }
}

export class CountryData {
    countryId: string;
    countryName: string;
}

export class DistanceToPlantReport {
    miles: number;
    siteID: number;
    siteName: string;
    city: string;
    zipCode: string;
    plantType: string;
    company: string;
}

export class ZipDeatils {
    countryId: string;
    zipCodeRoot: string;
    region1: string;
    city: string;
}